// extracted by mini-css-extract-plugin
module.exports = {"emailConfigurationPage":"EmailConfiguration_emailConfigurationPage__19K8_","action":"EmailConfiguration_action__2roF2","recipient":"EmailConfiguration_recipient__1bRNX"};